/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AttachmentsBody model module.
 * @module model/AttachmentsBody
 * @version v0.3
 */
export default class AttachmentsBody {
  /**
   * Constructs a new <code>AttachmentsBody</code>.
   * @alias module:model/AttachmentsBody
   * @class
   * @param fileType {module:model/AttachmentsBody.FileTypeEnum} 
   * @param file {Blob} 
   */
  constructor(fileType, file) {
    this.fileType = fileType;
    this.file = file;
  }

  /**
   * Constructs a <code>AttachmentsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AttachmentsBody} obj Optional instance to populate.
   * @return {module:model/AttachmentsBody} The populated <code>AttachmentsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AttachmentsBody();
      if (data.hasOwnProperty('user_id'))
        obj.userId = ApiClient.convertToType(data['user_id'], 'String');
      if (data.hasOwnProperty('identity_id'))
        obj.identityId = ApiClient.convertToType(data['identity_id'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('file_type'))
        obj.fileType = ApiClient.convertToType(data['file_type'], 'String');
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
    }
    return obj;
  }
}

/**
 * @member {String} userId
 */
AttachmentsBody.prototype.userId = undefined;

/**
 * @member {String} identityId
 */
AttachmentsBody.prototype.identityId = undefined;

/**
 * @member {String} description
 */
AttachmentsBody.prototype.description = undefined;

/**
 * Allowed values for the <code>fileType</code> property.
 * @enum {String}
 * @readonly
 */
AttachmentsBody.FileTypeEnum = {
  /**
   * value: "full_drivers_license"
   * @const
   */
  fullDriversLicense: "full_drivers_license",

  /**
   * value: "other"
   * @const
   */
  other: "other",

  /**
   * value: "drivers_license_front"
   * @const
   */
  driversLicenseFront: "drivers_license_front",

  /**
   * value: "drivers_license_back"
   * @const
   */
  driversLicenseBack: "drivers_license_back",

  /**
   * value: "lab_result"
   * @const
   */
  labResult: "lab_result",

  /**
   * value: "personal_image"
   * @const
   */
  personalImage: "personal_image",

  /**
   * value: "patient_document"
   * @const
   */
  patientDocument: "patient_document",

  /**
   * value: "bill"
   * @const
   */
  bill: "bill",

  /**
   * value: "invoice"
   * @const
   */
  invoice: "invoice"
};
/**
 * @member {module:model/AttachmentsBody.FileTypeEnum} fileType
 */
AttachmentsBody.prototype.fileType = undefined;

/**
 * @member {Blob} file
 */
AttachmentsBody.prototype.file = undefined;

